import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class ApplicationTypeStore {
  root;
  applicationType = null;
  isSecondaryApplication = false;
  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream() {
    groupByFunction(
      'messageType',
      'applicationType',
      this.root.websocketSubject
    ).subscribe((msg) => {
      this.handleApplicationType(msg)
    });
    groupByFunction(
      'messageType',
      'isSecondaryApplication',
      this.root.websocketSubject
    ).subscribe((msg) => {
      this.handleSecondaryApplication(msg)
    });
  }

  handleApplicationType = (msg) => {
    this.applicationType = msg.name;
  }
  handleSecondaryApplication = (msg) => {
    if (msg.isSecondaryApplication) this.isSecondaryApplication = false;
    else this.isSecondaryApplication = false;
  }
}

